import * as React from 'react';
import { MediaQuery, Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const CLSelectLabel = ({ name , eyeSideId , htmlFor  })=>{
    const { getLabel  } = useIntl();
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement("div", {
        className: "cl-select-label__label-wrapper"
    }, /*#__PURE__*/ React.createElement("label", {
        htmlFor: htmlFor,
        className: "cl-select-label__label"
    }, getLabel(`products.contactLenses.prescription.${name}`)), /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${eyeSideId}-${name}-tooltip`,
        "data-t": `tooltip-${eyeSideId}`,
        className: "cl-select-label__tooltip",
        message: getLabel(`products.contactLenses.prescription.${name}.tooltip`),
        boundariesElement: isDesktop ? 'window' : 'scrollParent'
    }));
};

export { CLSelectLabel };
//# sourceMappingURL=CLSelectLabel.js.map
